'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.getContact = getContact;
var GET_CU_CONTACT = 'bp/cu/contact/GET_CU_CONTACT';
var GET_CU_CONTACT_SUCCESS = 'bp/cu/contact/GET_CU_CONTACT_SUCCESS';
var GET_CU_CONTACT_FAIL = 'bp/cu/contact/GET_CU_CONTACT_FAIL';

var initialState = {
    contact: {},
    cuHashId: ""
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case GET_CU_CONTACT:
            return _extends({}, state, {
                contact: {},
                cuHashId: action.cuHashId
            });
        case GET_CU_CONTACT_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                contact: action.result.data.data
            });
        default:
            return state;
    }
}

function getContact(cuHashId) {
    return {
        types: [GET_CU_CONTACT, GET_CU_CONTACT_SUCCESS, GET_CU_CONTACT_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/cu_school/contact?schoolHashId=' + cuHashId);
            }

            return promise;
        }(),
        cuHashId: cuHashId
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/cu/cuContact.js
// module id = 454
// module chunks = 0